import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  createInput,
  createSelect,
  updateMiniProgramGov,
  formData,
  getMiniProgramGovList,
  updateList,
  setFormData,
  showMiniProgramGov,
  id,
  history,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateMiniProgramGov(id, formData, ({ data }) => {
      setModal({ isOpen: false });
      getMiniProgramGovList();
      showMiniProgramGov(id);
      history.push(`/general-settings/mini-program-government/${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'icon_url', label: 'Icon:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'sequence', label: 'Sequence:' },
              { required: true, type: 'number' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'description', label: 'Description:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'redirect_url', label: 'Redirect URL:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Select Type',
                key: 'type',
                label: 'Government Type',
              },
              c.GOV_TYPE_LIST
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  updateMiniProgramGov: PropTypes.instanceOf(Function).isRequired,
  getMiniProgramGovList: PropTypes.instanceOf(Function).isRequired,
  showMiniProgramGov: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
